import { render } from "./HomeView.vue?vue&type=template&id=16ead4a3"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\mehboob\\flymall\\New folder\\updated6in1\\crashwinmakaz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__